import type { JSX } from 'react';

import { Spinner } from '@change/ds-core-ui';

import { Flex } from '@change-corgi/design-system-legacy/layout';

import { withPrefetchedData } from 'src/shared/prefetch';

import { prefetchPageContext, StartAPetitionPageContextProvider } from 'src/app/pages/startAPetition/pageContext';
import type { StartAPetitionPagePrefetchedDataProps } from 'src/app/pages/startAPetition/pageContext';

import { Head } from '../components/Head';
import { StartAPetitionLayout } from '../layout';

import { StartAPetitionErrorHandler } from './ErrorHandler';
import { MutationObserverContainer } from './MutationObserverContainer';

/**
 * TODO: move the `<Head>` component to the layout once the page state
 * context can be server rendered.
 *
 * See `src/app/pages/startAPetition/pageContext/provider.tsx` for details
 */
export const StartAPetition = withPrefetchedData(
	({ prefetchedData }: StartAPetitionPagePrefetchedDataProps): JSX.Element => {
		return (
			<MutationObserverContainer>
				<StartAPetitionPageContextProvider
					prefetchedData={prefetchedData}
					errorHandler={StartAPetitionErrorHandler}
					loadingFallback={
						<>
							<Head />
							<Flex
								sx={{
									alignItems: 'center',
									justifyContent: 'center',
									height: ['calc(100vh - 48px)', 'calc(100vh - 58px)'],
									width: '100%',
								}}
							>
								<Spinner data-testid="loading-spinner" />
							</Flex>
						</>
					}
				>
					<Head />
					<StartAPetitionLayout />
				</StartAPetitionPageContextProvider>
			</MutationObserverContainer>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context),
	},
);
